// v0.249.0 — PREVIEW FEATURES. Brett, 2026-09-29: "Yes keep it out of the
// app" — floor scan stays his while he works on it, and stays out of the App
// Store build (Apple 2.3.1 turns away unfinished features).
//
// WHO may use a preview is decided on the server (api/shared/preview.js) and
// arrives with the signed-in user as `Preview`, e.g. ['floor-scan']. This only
// reads it, so nothing in a browser can switch one on; the API refuses the
// calls as well. Call sites pass getCurrentUser().
//
// The App Store build (`npm run build:store`, VITE_STORE_BUILD=1) has no
// previews at all, and leaves the floor-scan page out of the files it ships.
export const STORE_BUILD = !!(import.meta.env && import.meta.env.VITE_STORE_BUILD === '1');

export function hasPreview(user, key, { store = STORE_BUILD } = {}) {
  if (store) return false;
  const list = user && (user.Preview || user.preview);
  return Array.isArray(list) && list.includes(key);
}
